import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "id", "type", "value", "rows", "placeholder"]
const _hoisted_2 = ["id"]

import {toRef, useAttrs} from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TextareaInput',
  props: {
    type: {
        type: String,
        default: "text",
    },
    value: {
        type: String,
        default: "",
    },
    modelValue: {
        type: String,
        default: "",
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    errorId: {
        type: String,
        default: null,
    },
    successMessage: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
     rows: {
        type: Number,
        default: null,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const attrs = useAttrs();

const props = __props;

const emit = __emit;

const name = toRef(props, "name");

const onHandlerChange = ($event) => {
    emit("update:modelValue", props.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("textarea", _mergeProps(_unref(attrs), {
      name: name.value,
      id: name.value,
      type: __props.type,
      value: props.modelValue,
      rows: __props.rows,
      class: ["form-control", {'is-invalid': !!__props.error}],
      placeholder: __props.placeholder,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value)))
    }), null, 16, _hoisted_1),
    _withDirectives(_createElementVNode("span", {
      id: __props.errorId,
      class: "invalid-feedback",
      role: "alert"
    }, _toDisplayString(__props.error), 9, _hoisted_2), [
      [_vShow, __props.error]
    ])
  ], 64))
}
}

})